module.exports = __webpack_public_path__ + "img/graduate-2018-songxiaowei.9921b7ed.jpg";